export default __webpack_public_path__ + "static/media/expense-viewer.2bdbeac6.png";